import { Component } from '@angular/core'
import { DefaultControlErrorComponent } from '@ngneat/error-tailor'

@Component({
    selector: 'app-error-message',
    templateUrl: './error-message.component.html'
})
export class ErrorMessageComponent extends DefaultControlErrorComponent {}
